// extracted by mini-css-extract-plugin
module.exports = {"Root":"Root__1G5Xo","Root--inline":"Root--inline__3yMm-"};